import { Box, TextField, Typography } from "@material-ui/core";
import React, { useRef } from "react";
import CloseIcon from "@material-ui/icons/Close";

interface Props {
  poundsAmount: number;
  percentForAddingCredits: number;
  amountOfAddedTickets: number;
  handleDeleteCredit: () => void;
  handleChangeCreditProps: (e: any) => void;
  countError?: boolean;
  percentError?: boolean;
  sortCreditsArrayOnBlur:()=>void
}

export const CreditRow = ({
  poundsAmount,
  percentForAddingCredits,
  amountOfAddedTickets,
  handleDeleteCredit,
  handleChangeCreditProps,
  countError,
  percentError,
  sortCreditsArrayOnBlur
}: Props) => {
  return (
    <Box display="flex" alignItems="center" marginBottom={1}>
      <Box className="creditPropfieldWrapper">
        <Box width={90} marginRight={1.5}>
          <TextField
            label=""
            size="small"
            variant="outlined"
            type="number"
            name="count"
            InputProps={{
              inputProps: {
                min: 1,
              },
              onBlur:sortCreditsArrayOnBlur
            }}
            error={countError}
            onChange={handleChangeCreditProps}
            value={poundsAmount||""}
          />
        </Box>
        <Typography variant="subtitle1">£</Typography>
        
      </Box>
      <Box
        display="flex"
        alignItems="center"
        className="creditPropfieldWrapper"
      >
        <Typography>Add</Typography>
        <Box width={90} marginRight={2}>
          <TextField
            label="%"
            size="small"
            variant="outlined"
            name="percent"
            type="number"
            InputProps={{
              inputProps: {
                min: 1,
              },
            }}
            error={percentError}
            onChange={handleChangeCreditProps}
            value={percentForAddingCredits||""}
          />
        </Box>
        <Typography>credits</Typography>
        <Box marginLeft={1} paddingTop={0.5}>
          <CloseIcon className="remove-discount" onClick={handleDeleteCredit} />
        </Box>
      </Box>
      <Box display="flex" alignItems="center" marginLeft={7}>
        <Typography>{`1£ = ${amountOfAddedTickets} credits`}</Typography>
      </Box>
    </Box>
  );
};
